import PropTypes from 'prop-types';
import React from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import styled from 'styled-components';
import {labels, setThousandSeparator} from '../../../../util/utils';
import CanvasFormInput from '../../CanvasForm/CanvasFormInput';
import {getFinancialPeriodAmountInUserFormat} from './MeasurementBasisConfig';
import NumberFormat from '../../NumberFormat/NumberFormat';
import {numericValueRegex} from '../../../../util/uiconstants';
import {useUserPreferences} from '../../../../util/customHooks';

function MeasurementBasisFinancialPeriod({
	className,
	financialPeriodAmount,
	isAnnualizedAmountExpectedToBeReported,
	rationale,
	isDisabled,
	setFinancialPeriodAmount,
	setLastFinancialPeriodAmountSaved,
	updateMateriality,
	onChange,
	onCancel
}) {
	const inputName = 'financial-period-amount-input';
	const userPreferences = useUserPreferences();

	let initialValue = getFinancialPeriodAmountInUserFormat(true, financialPeriodAmount, userPreferences);

	async function handleOnAccept(value) {
		setFinancialPeriodAmount(value);
		setLastFinancialPeriodAmountSaved(value);
		return updateMateriality(value, rationale, isAnnualizedAmountExpectedToBeReported, inputName);
	}

	return (
		<StyledMeasurementBasisFinancialPeriod className={className}>
			<CanvasFormInput
				clearButtonTitle={labels.clearHoverText}
				name={inputName}
				id="financialPeriodAmount"
				label={labels.enterExpectedFinancialPerioadAmount}
				maxLength={15}
				onChange={(currentValue) => onChange(inputName, initialValue, currentValue)}
				onAccept={handleOnAccept}
				onCancel={() => onCancel(inputName)}
				pattern={numericValueRegex}
				progressBarClassName="savefinancial-loader"
				showLabel
				type="integer"
				value={initialValue}
				showProgressBar={false}
				disabled={isDisabled}
			/>
		</StyledMeasurementBasisFinancialPeriod>
	);
}

MeasurementBasisFinancialPeriod.propTypes = {
	className: PropTypes.string,
	financialPeriodAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isAnnualizedAmountExpectedToBeReported: PropTypes.bool,
	lastFinancialPeriodAmountSaved: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	rationale: PropTypes.string,
	setFinancialPeriodAmount: PropTypes.func.isRequired,
	setLastFinancialPeriodAmountSaved: PropTypes.func.isRequired,
	updateMateriality: PropTypes.func.isRequired
};

MeasurementBasisFinancialPeriod.defaultProps = {
	className: 'financialperiod-container'
};

const StyledMeasurementBasisFinancialPeriod = styled.section`
	position: relative;
	margin-bottom: var(--px-25);
	display: flex;
	flex-direction: column;
	height: var(--px-45);

	.canvas-form-input {
		height: var(--px-44);
		width: var(--px-600);

		.StyledCanvasFormInputDisplay {
			height: var(--px-44);
			padding-left: var(--px-7);
			.StyledCanvasFormInputValue {
				padding-top: var(--px-12);
			}
		}
	}

	.canvas-form-input-text,
	.styled-input,
	#financialPeriodAmount {
		width: 100%;
	}
`;

export default MeasurementBasisFinancialPeriod;
